<template>
  <div>
    <!-- [ Modal form feedback ] start -->
    <sweet-modal blocking :title="title" ref="feedback" class="modal" v-on:close="closeModal">

      <div v-if="!click" class="feedback">
        <div @click="selectedFeedback(2)" class="feedback__item feedback__item_error">{{$t('modal_feedback_error')}}<i class="fas fa-exclamation-triangle"></i></div>
        <div @click="selectedFeedback(3)" class="feedback__item feedback__item_help">{{$t('modal_feedback_help')}}<i class="fas fa-question-circle"></i></div>
        <div @click="selectedFeedback(1)" class="feedback__item feedback__item_success">{{$t('modal_feedback_feedback')}}<i class="fas fa-thumbs-up"></i></div>
        <div @click="selectedFeedback(4)" class="feedback__item feedback__item_enquiries">{{$t('modal_feedback_enquiries')}}<i class="fas fa-comment-dots"></i></div>
        <div @click="selectedFeedback(5)" class="feedback__item feedback__item_enquiries">{{$t('modal_feedback_accounting_issues')}}<i class="fas fa-calculator"></i></div>

      </div>

      <el-form v-if="click" :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">

        <el-form-item prop="subject">
          <el-input v-model="form.subject" :label="$t('modal_subject')"></el-input>
        </el-form-item>
        <vue-editor
          useCustomImageHandler
          @image-added="handleImageAdded"
          prop="aboutThisProject"
          v-model="form.message"
          style="margin-bottom: 20px;">
        </vue-editor>

        <el-form-item class="modal__btn">
          <el-button @click="selectedFeedback">{{$t('general_cancel')}}</el-button>
          <el-button :disabled="!(form.message)" @click="submitForm('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>

      </el-form>

    </sweet-modal>
    <!-- [ Modal form feedback ] end -->
  </div>
</template>

<script>
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default {
  components: {
    SweetModal,

    VueEditor,
  },
  props: ['feedback'],
  data() {
    return {

      click: false,

      form: {
        type: 0,
        message: '',
        subject: ''
      },
      rules: {
        subject: [{
          required: true,
          message: 'Subject is required',
          trigger: 'change'
        }],
      }
    }
  },
  computed: {
    title: function () {
      return (this.form.type === 0) ? this.$t('modal_feedback') :
             (this.form.type === 1) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_feedback')}` :
             (this.form.type === 2) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_error')}` :
             (this.form.type === 3) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_help')}` :
             (this.form.type === 4) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_enquiries')}` :
             (this.form.type === 5) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_accounting_issues')}` : this.$t('modal_feedback')

    }
  },
  methods: {
    closeModal() {
      this.click = false
      this.form.type = 0
      this.form.message = ''
      this.form.subject = ''
    },
    selectedFeedback(type) {
      this.form.type = type
      this.form.message = ''
      this.form.subject = ''
      if (this.click == true) {
        this.click = false
        this.form.type = 0
      } else {
        this.click = true
      }
    },
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid && this.form.message) {
          console.log('submit');

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/feedback/create?companyId=${this.$route.query.companyId}`, {
              subjectType: this.form.type,
              message: this.form.message,
              subject: this.form.subject
            })
            .then(response => {
              this.notification("Success", "Thank you for report", "success");
              this.form.message = ''
              this.form.subject = ''
              this.click = false
              this.$refs.feedback.close();
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData();
      formData.append('file', file);

      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
        .then(response => {
          let url = response.data.fileUrl // Get url from response
          Editor.insertEmbed(cursorLocation, 'image', url);
          resetUploader();
        })
        .catch(error => {
          console.log('An error occurred:', error);
        })
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.feedback {
  &__item {
    font-size: 18px;
    color: #888;
    padding: 10px 15px;
    cursor: pointer;
    &_success {
      position: relative;
      i {
        position: absolute;
        top: 30%;
        right: 15px;
        color: #67c23a;
      }
      &:hover {
        background: #f0f9eb;
      }
    }
    &_error {
      position: relative;
      i {
        position: absolute;
        top: 30%;
        right: 15px;
        color: #f56c6c;
      }
      &:hover {
        background: #fef0f0;
      }
    }
    &_help {
      position: relative;
      i {
        position: absolute;
        top: 30%;
        right: 15px;
        color: #000;
      }
      &:hover {
        background: #fff4e3;
      }
    }
    &_enquiries {
      position: relative;
      i {
        position: absolute;
        top: 30%;
        right: 15px;
        color: #f5ad3b;
      }
      &:hover {
        background: #fff4e3;
      }
    }
  }
}

.modal {
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
}
</style>
